import { render, staticRenderFns } from "./preguntas-frecuentes.vue?vue&type=template&id=3d7574e3&scoped=true"
import script from "./preguntas-frecuentes.vue?vue&type=script&lang=js"
export * from "./preguntas-frecuentes.vue?vue&type=script&lang=js"
import style0 from "./preguntas-frecuentes.vue?vue&type=style&index=0&id=3d7574e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7574e3",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderMain: require('/builds/marketing/abstracta.academy-website/components/HeaderMain.vue').default,Accordion: require('/builds/marketing/abstracta.academy-website/components/Accordion.vue').default})
